import React, { useState } from "react";
import { ActionContainer } from "./styles";
import { UserPopoverProps } from "./types";
import { CiLogout } from "react-icons/ci";
import useAuth from "../../hooks/useAuth";
import { Dropdown, MenuProps } from "antd";
import { FaUser } from "react-icons/fa";
import ThemeColors from "../../themes/colors";
import PasswordReset from "../PasswordReset";
import { MdOutlinePassword } from "react-icons/md";

const UserPopover: React.FC<UserPopoverProps> = ({}): JSX.Element => {
  const { logout } = useAuth();

  const [passwordModal, setPasswordModal] = useState(false);

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: "Minha Conta",
      disabled: true,
    },
    {
      type: "divider",
    },
    {
      key: "2",
      label: "Alterar Senha",
      icon: <MdOutlinePassword  />,
      onClick: () => setPasswordModal(true),
    },
    {
      key: "3",
      label: "Sair",
      icon: <CiLogout />,
      onClick: () => logout(),
    },
  ];

  return (
    <ActionContainer>
      <Dropdown menu={{ items }}>
        <FaUser color={ThemeColors.Bg300} style={{ cursor: "pointer" }} />
      </Dropdown>
      <PasswordReset
        isModalOpen={passwordModal}
        setIsModalOpen={setPasswordModal}
      />
    </ActionContainer>
  );
};

export default UserPopover;
